// utils/exportAsPDF.tsx
import React from 'react';

// Third party
import html2pdf from 'html2pdf.js';
import dayjs, { Dayjs } from 'dayjs';

// Components
import { FilterType } from '../features/ClientAdmin/Usage/types';

type ExportAsPdfProps = {
  reportRef: React.RefObject<HTMLElement | null>;
  selectedDate: Dayjs | null;
  customFromDate: Dayjs | null;
  customToDate: Dayjs | null;
  activeFilterType: FilterType;
};

const exportAsPDF = async ({
                             reportRef,
                             selectedDate,
                             customFromDate,
                             customToDate,
                             activeFilterType,
                           }: ExportAsPdfProps): Promise<void> => {
  if (!reportRef.current) return;

  await new Promise((r) => setTimeout(r, 300));

  const formatRange = (): string => {
    if (activeFilterType === 'day' && selectedDate) {
      return dayjs(selectedDate).format('DD/MM/YYYY');
    }
    if (activeFilterType === 'month' && selectedDate) {
      return dayjs(selectedDate).format('MMMM YYYY');
    }
    if (activeFilterType === 'year' && selectedDate) {
      return dayjs(selectedDate).format('YYYY');
    }
    if (activeFilterType === 'custom' && customFromDate && customToDate) {
      return `${dayjs(customFromDate).format('DD/MM/YYYY')} - ${dayjs(customToDate).format('DD/MM/YYYY')}`;
    }
    return 'All time';
  };

  const rangeLabel = formatRange();

  const filename = selectedDate
    ? `session-${dayjs(selectedDate).format('DD/MM/YYYY')}.pdf`
    : customFromDate && customToDate
      ? `usage-${dayjs(customFromDate).format('DD/MM/YYYY')}_to_${dayjs(customToDate).format('DD/MM/YYYY')}.pdf`
      : 'sessions.pdf';

  const wrapper = document.createElement('div');
  wrapper.style.backgroundColor = '#161B22';
  wrapper.style.color = '#FFFFFF';
  wrapper.style.fontFamily = 'Inter, Roboto, system-ui, -apple-system, Segue UI, Arial, sans-serif';

  const header = document.createElement('div');
  header.style.display = 'flex';
  header.style.alignItems = 'center';
  header.style.gap = '24px';
  header.style.padding = '12px 16px';
  header.style.borderBottom = '1px solid #394047';
  header.style.backgroundColor = '#161B22';

  const rangeEl = document.createElement('div');
  rangeEl.style.fontWeight = '700';
  rangeEl.style.fontSize = '16px';
  rangeEl.textContent = rangeLabel;

  const accountEl = document.createElement('div');
  accountEl.style.fontSize = '14px';
  accountEl.style.color = '#9CA3AF';
  //accountEl.textContent = `Account Type: ${accountTypeLabel}`;

  header.appendChild(rangeEl);
  header.appendChild(accountEl);

  const clonedReport = reportRef.current.cloneNode(true) as HTMLElement;

  clonedReport.style.width = '100%';

  wrapper.appendChild(header);
  wrapper.appendChild(clonedReport);

  await html2pdf()
    .set({
      margin: 0.5,
      filename,
      jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
      html2canvas: {
        backgroundColor: '#161B22',
        useCORS: true,
        scale: 2,
      },
    })
    .from(wrapper)
    .save();
};

export { exportAsPDF };
